<template>
  <div
    class="step-heading row align-items-center pt-7 pb-6 py-xl-8 gap-6 gap-xl-0"
  >
    <!-- Steps -->
    <div class="col-12 col-xl-6 order-xl-2">
      <div
        class="step-heading__steps row flex-nowrap justify-content-around gx-2"
      >
        <div v-for="(step, index) in flowSteps" :key="step.id" class="col-auto">
          <div
            class="progress-step"
            :class="{
              'progress-step--active': index === currentStepIndex,
              'progress-step--completed':
                index !== currentStepIndex && isStepCompleted(index),
            }"
            @click="goToStep(index)"
            role="button"
            tabindex="0"
            :aria-label="`Ga naar stap ${index + 1}: ${step.title}`"
            @keydown.enter.prevent="goToStep(index)"
            @keydown.space.prevent="goToStep(index)"
          >
            <div class="progress-step__icon">
              <span
                v-if="isStepCompleted(index)"
                class="icon icon-checkmark"
              ></span>
              <span v-else>{{ index + 1 }}</span>
            </div>
            <div class="progress-step__title">{{ step.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Title -->
    <div class="col-12 col-xl-6">
      <span v-if="subtitle" class="d-block text-gray-600">{{ subtitle }}</span>
      <h2>{{ stepTitle }}</h2>
    </div>
  </div>
</template>

<script>
import { getFlowSteps, getStepByIndex } from './config/flowConfig.js';

export default {
  name: 'StepHeading',
  props: {
    flowType: { type: String, required: true },
    currentStep: {
      type: [String, Number],
      required: true,
    },
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['go-to-step'],
  computed: {
    numericStep() {
      return Number(this.currentStep);
    },
    currentStepObj() {
      return getStepByIndex(this.flowType, this.numericStep) || {};
    },
    stepTitle() {
      return this.currentStepObj.stepTitle || '';
    },
    subtitle() {
      return this.currentStepObj.subtitle || '';
    },
    flowSteps() {
      return getFlowSteps(this.flowType);
    },
    currentStepIndex() {
      return this.numericStep;
    },
  },
  methods: {
    goToStep(stepIndex) {
      // Valideer stepIndex voordat emit
      if (
        typeof stepIndex !== 'number' ||
        stepIndex < 0 ||
        stepIndex >= this.flowSteps.length
      ) {
        return;
      }

      // Alle stappen zijn altijd toegankelijk
      this.$emit('go-to-step', stepIndex);
    },
    isStepCompleted(index) {
      const step = this.flowSteps[index];
      if (!step) return false;

      switch (step.sidebarType) {
        case 'base':
          return !!this.configData.basePackage;
        case 'products':
          return (
            this.configData.products && this.configData.products.length > 0
          );
        case 'foodDrinks':
          return (
            this.configData.foodDrinks && this.configData.foodDrinks.length > 0
          );
        case 'packaging':
          return (
            (this.configData.packagingMode === 'product' &&
              !!this.configData.packagingProduct) ||
            (this.configData.packagingMode === 'box' &&
              !!this.configData.packaging)
          );
        case 'personalization':
          // Check if any products have personalization selected
          return (
            this.configData.personalization?.selectedCard ||
            (this.configData.personalization?.productPersonalization &&
              Object.values(
                this.configData.personalization.productPersonalization,
              ).some(
                (item) =>
                  item && (item.sticker || item.zeefdruk || item.graveren),
              ))
          );
        default:
          return false;
      }
    },
  },
};
</script>
